export const handleFocusChange = (nextRef, nextValueRef, resetRef, timer) => {

  if (nextValueRef.current < nextRef.length && resetRef.current === 0) {
    if (
      nextRef[nextValueRef.current]?.current?.value === null ||
      nextRef[nextValueRef.current]?.current?.value === ""
    ) {
      timer = null;
      nextRef[nextValueRef.current].current.focus();
    } else {
      nextValueRef.current = nextValueRef.current + 1;
      handleFocusChange(nextRef, nextValueRef, resetRef, timer);
    }
  } else if (resetRef.current === 1) {
    resetRef.current = 0;
    handleFocusChange(nextRef, nextValueRef, resetRef, timer);
  }

};

export const skipFocusChange = (nextRef, nextValueRef, handleFocusChange, resetRef, timer) => {
  if (nextValueRef.current < nextRef.length && resetRef.current === 0) {
    nextRef[nextValueRef.current].current.value = "skip";
    nextValueRef.current = nextValueRef.current + 1;
    handleFocusChange(nextRef, nextValueRef, resetRef, timer);
  } else if (resetRef.current === 1 && nextValueRef.current < nextRef.length) {
    nextValueRef.current = nextValueRef.current + 1;
    handleFocusChange(nextRef, nextValueRef, resetRef, timer);
  }
};
